import { NavBar } from 'components/NavBar/NavBar'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Options } from 'components/Options/Options'
import { Pagination } from 'components/Pagination/Pagination'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { setConfirmModal } from 'features/global/globalSlice'
import { clearCostCenter, deleteCostCenterItem, getCostCenterItems } from 'features/inventory/inventoryCostCenterSlice'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { Flex, MainHeadline, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { IGetAllCostCenterItemsSingleResponse } from 'types/api/inventoryCostCenterApi.interface'
import { ModalTypes } from 'types/global.interface'
import { getParams, handlePagination } from 'utils/helpers'
import { IInventoryCostCenterModal, InventoryCostCenterModal } from './InventoryCostCenterModal'

export const InventoryCostCenter = () => {
    const dispatch = useDispatch<AppDispatch>()
    const { costCenterItems, totalPages } = useSelector((store: RootState) => store.inventoryCostCenter)
    const [params, setParams] = useState<any>(getParams({ location }))
    const [modal, setModal] = useState({ open: false, value: null })

    useQueryPagination({ fetchFunctions: [getCostCenterItems], cleanUpFunctions: [clearCostCenter], params })

    const transformDataForModal = (item: IGetAllCostCenterItemsSingleResponse): IInventoryCostCenterModal => {
        return {
            id: item.id,
            name: item.name,
            code: item.code,
            ownerUser: {
                value: item.ownerUser.id,
                label: item.ownerUser.firstName + ' ' + item.ownerUser.lastName
            },
            parentCostCenter: item.parentCostCenter
                ? { value: item.parentCostCenter.id, label: item.parentCostCenter.name }
                : null,
        }
    }

    const removeRecord = (id: number) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteCostCenterItem(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                    noItems: costCenterItems.length < 2,
                },
                word: 'delete record',
            }),
        )
    }

    const columns: IHonestTableColumn<any>[] = [
        { id: 'name', header: 'NAME', cell: (item) => item.name },
        { id: 'code', header: 'CODE', cell: (item) => item?.code },
        { id: 'owner', header: 'OWNER', cell: (item) => item?.ownerUser.firstName + ' ' + item?.ownerUser.lastName },
        {
            id: 'actions',
            header: '',
            align: 'right',
            cell: (item) => (
                <span onClick={(e) => e.stopPropagation()}>
                    <Options item={item} title='Cost Center' openModal={() => setModal({ open: true, value: transformDataForModal(item) })} handleRemove={removeRecord} />
                </span>
            ),
        },
    ]

    return <>
        <NavBar input setParams={setParams} placeholder='Search...' />
        <PageWrapper>
            <Flex between center mb='16' >
                <MainHeadline>Cost Center</MainHeadline>
                <Button variant='primary' onClick={() => setModal({ open: true, value: null })} >
                    Add Record
                </Button>
            </Flex>
            {!costCenterItems.length ? (
                <NoItems title='Records' />
            ) : (
                <HonestTable columns={columns} data={costCenterItems} keyField='id' />
            )}
            {modal.open && <InventoryCostCenterModal closeModal={() => setModal({ open: false, value: null })} value={modal.value} />}
        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}
